"use client";

import React, { useState, useEffect } from "react";
import { MapPin, Clock, Navigation, Phone, Mail } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
export default function OurAirportHub() {
  const [localTime, setLocalTime] = useState<string>("");
  useEffect(() => {
    const updateTime = () => {
      const now = new Date();
      const formatter = new Intl.DateTimeFormat("en-US", {
        timeZone: "Africa/Kinshasa",
        hour: "2-digit",
        minute: "2-digit",
        hour12: true
      });
      setLocalTime(formatter.format(now));
    };
    updateTime();
    const interval = setInterval(updateTime, 60000);
    return () => clearInterval(interval);
  }, []);
  return <section id="our-airport-hub" className="dark bg-background text-foreground relative w-full h-[600px] md:h-[700px] overflow-hidden flex items-center justify-center">
      {}
      <div className="absolute inset-0 w-full h-full bg-cover bg-center bg-no-repeat opacity-80" style={{
      backgroundImage: "url('https://wpvc-images.s3.us-east-1.amazonaws.com/images/1591502/img/dark_monochrome_map_kinshasa.png')"
    }} />
      
      {}
      <div className="absolute inset-0 bg-radial from-transparent to-background/80 pointer-events-none" />

      {}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 flex flex-col items-center animate-in fade-in zoom-in duration-1000">
        <div className="relative">
          <MapPin className="size-14 text-primary drop-shadow-[0_0_15px_rgba(255,170,0,0.6)] relative z-10" fill="currentColor" />
          {}
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 size-10 bg-primary/30 rounded-full animate-ping" />
        </div>
      </div>

      {}
      <div className="absolute bottom-6 left-4 right-4 md:bottom-12 md:left-12 md:right-auto md:w-[400px] z-20">
        <Card className="bg-card/90 backdrop-blur-md border-border/50 shadow-2xl shadow-black/50">
          <CardHeader className="pb-4">
            <div className="flex items-center justify-between mb-2">
              <span className="text-xs font-bold tracking-wider text-primary uppercase">
                Primary Hub
              </span>
              {localTime && <div className="flex items-center gap-1.5 text-xs font-medium text-muted-foreground bg-secondary/50 px-2.5 py-1 rounded-full">
                  <Clock className="size-3.5 text-primary" />
                  <span>{localTime} WAT</span>
                </div>}
            </div>
            <CardTitle className="text-2xl font-serif tracking-tight">
              N'djili International Airport
            </CardTitle>
            <CardDescription className="text-muted-foreground">
              Strategic operations center for Handling and Logistic Company (HLC) in DR Congo.
            </CardDescription>
          </CardHeader>
          <CardContent className="space-y-4 pb-6">
            <div className="space-y-3 text-sm">
              <div className="flex items-start gap-3">
                <MapPin className="size-4 text-primary shrink-0 mt-0.5" />
                <span className="text-foreground/90">
                  N’djili International Airport, Kinshasa, DR Congo
                </span>
              </div>
              <div className="flex items-center gap-3">
                <Phone className="size-4 text-primary shrink-0" />
                <span className="text-foreground/90">+243 810 641 198</span>
              </div>
              <div className="flex items-center gap-3">
                <Mail className="size-4 text-primary shrink-0" />
                <span className="text-foreground/90">ddchambangi@gmail.com</span>
              </div>
            </div>
          </CardContent>
          <CardFooter className="pt-0">
            <Button asChild className="w-full group" size="lg">
              <Link to="https://maps.google.com/?q=N'djili+International+Airport,+DR+Congo" newTab>
                <Navigation className="size-4 mr-2 group-hover:translate-x-1 transition-transform" />
                Get Directions
              </Link>
            </Button>
          </CardFooter>
        </Card>
      </div>
    </section>;
}